import { useForm } from "react-hook-form";
import { zodResolver } from "@hookform/resolvers/zod";
import { costMasterSchema } from "./schema";
import { fetchCostMasterData } from "./read";
import { useUpdateCostMaster } from "../update/mutation";
import { useCreateCostMaster } from "../create/mutation";

export const useCostMasterForm = ({ costmasterId }) => {
  const form = useForm({
    resolver: zodResolver(costMasterSchema),
    defaultValues: {
      department: "",
      grade: "",
      hourly_cost: "",
    },
  });

  const updateCostMaster = useUpdateCostMaster();
  const createCostMaster = useCreateCostMaster();

  const handleCreate = async (context) => {
    const item = context.values;
    await createCostMaster.mutateAsync({ item });
  };

  const handleUpdate = async (id, context) => {
    const values = context.dirtyValues;
    await updateCostMaster.mutateAsync({ costmasterId: id, item: values });
  };

  const handleRead = async (id) => {
    const response = await fetchCostMasterData({ costmasterId: id });
    return response;
  };

  return {
    form,
    handleCreate,
    handleUpdate,
    handleRead,
  };
};
